module.exports = __webpack_public_path__ + "img/alert-docs.96e2b48.svg";